<div class="affiliate_page_wrap">
    <div class="affiliate_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="affi_top_contents">
                        <h1>Promova a Trinka e Ganhe Muito Mais!</h1>
                        <a id="signUpAtShareASale" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            Inscreva-se no ShareASale
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="benefits_sections">
        <div class="benefits_outer">
            <div class="commission_sections">
                <div class="commission_header">
                    <img src="../../../assets/images/CommisionDetails.png" alt="details">
                    <h2>Detalhes da Comissão</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <!-- <li>Inscrições grátis - $ 0,30</li> -->
                        <li>Assinatura de plano pago - 25%</li>
                    </ul>
                </div>
            </div>

            <div class="commission_sections OtherBenefits_section">
                <div class="commission_header">
                    <img src="../../../assets/images/otherBenefits.png" alt="benefits">
                    <h2>Outros benefícios</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <li>Ótimas taxas de conversão (20-25%)</li>
                            <li>Rastreamento entre dispositivos</li>
                            <li>Janela estendida de cookies de 90 dias</li>
                            <li>Recompensas para antecipações</li>
                            <li>Suporte aos Afiliados de Primeira Classe</li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Commision Details</h2>
                        <ul>
                            <li>Free Sign-ups - $0.21</li>
                            <li>Paid plan subscription - $20</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Other Benefits</h2>
                        <ul>
                            <li>Great conversion rates (20-30%)</li>
                            <li>Cross-device tracking</li>
                            <li>Extended 90-day cookie window</li>
                            <li>Early bird rewards</li>
                            <li>Top-class affiliate support</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div> -->
    </div>


    <div class="why_become_affiliate_sectioin">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h2>Por que se tornar um Afiliado?</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Correções gramaticais e de frases podem ser uma tarefa difícil, e a maioria das ferramentas de verificação gramatical on-line tem dificuldades quando se trata de redação acadêmica e técnica. A Trinka aproveita as tecnologias de IA e ML juntamente com décadas de experiência no setor para fornecer todas as sugestões essenciais necessárias para escrever um trabalho técnico livre de erros ou trabalho acadêmico técnico. A Trinka é totalmente gratuita e disponível para uso online, como um plugin de navegador e plugin de MS Word.
                    </p>
                    <p>Ao fazer parceria com a Trinka, você não estará apenas ajudando os profissionais e instituições acadêmicas, mas também ganhará um fluxo constante de receita com o mínimo de esforço. A Trinka cuidará de todo o trabalho pesado para que você possa continuar a se concentrar no que faz melhor e manter o relacionamento com os clientes, fornecendo-lhes o conteúdo e as recomendações mais recentes e úteis. </p>
                </div>
                <div class="col-md-3">
                    <div class="affiliate_img">
                        <img src="../../../assets/images/anAffiliate.png" alt="affiliate">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="Affiliate_FAQ_Seciton">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="faq_affiliate_sections">
                        <h2>Afiliados FAQs</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header" id="heading-1">
                                <h5 class="mb-0">
                                    <a role="button" data-toggle="collapse" href="#collapse-1" aria-expanded="true"
                                        aria-controls="collapse-1">
                                        Sobre o Programa de Afiliados Trinka
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-1" class="collapse show" data-parent="#accordion"
                                aria-labelledby="heading-1">
                                <div class="card-body">
                                    <p>O programa de afiliados da Trinka funciona de uma maneira simples e eficiente - você coloca um banner ou um link de texto de rastreamento em seu site (ou perfil de mídia social, e-mail, e-book, etc.), e você é pago toda vez que um usuário indicado por você assina o nosso plano premium. Como temos uma alta taxa de conversão e uma taxa de comissão atraente para cada atualização paga bem-sucedida, os afiliados podem ganhar muito sem um discurso de vendas excessivamente assertivo. Divulgar a Trinka é suficiente, mas os melhores desempenham pagamentos mais altos.
                                    </p>
                                    <p>Para todas as dúvidas, envie um e-mail para <a
                                            href="mailto:marketing@trinka.ai.">marketing@trinka.ai.</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="heading-2">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-2"
                                        aria-expanded="false" aria-controls="collapse-2">
                                        Quem pode se tornar um afiliado da Trinka?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-2" class="collapse" data-parent="#accordion" aria-labelledby="heading-2">
                                <div class="card-body">
                                    <p>A Trinka ajuda pessoas em todo o mundo - estudantes, pesquisadores, cientistas, profissionais, entusiastas do idioma e todos que escrevem em inglês. O programa de afiliados da Trinka se encaixa perfeitamente com sites ou blogs vinculados à escrita de artigos e pesquisas. Além disso, temos vários afiliados prósperos cujo conteúdo enfatiza na educação, ciência, tecnologia, desenvolvimento de carreira e várias outras áreas que atraem a base de usuários diversificada da Trinka.
                                    </p>
                                    <p>Você pode maximizar suas chances de entrar em nosso programa de afiliados criando conteúdo que esteja em sincronia com nossa missão e garantindo que seja relevante, bem estruturado e atualizado. </p>
                                        
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-3">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-3"
                                        aria-expanded="false" aria-controls="collapse-3">
                                        Como posso me tornar um Afiliado da Trinka?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-3" class="collapse" data-parent="#accordion" aria-labelledby="heading-3">
                                <div class="card-body">
                                    <p>Assim que for aceito no programa, você receberá uma variedade de banners e links de afiliados. Se preferir, você pode utilizar boletins informativos e e-mails para promover a Trinka.</p>
                                    <p>Ao colocar nossos banners e / ou links, certifique-se de adicioná-los a páginas com conteúdo valioso e adequado. Como prática recomendada, não coloque os links e banners próximos a vários outros banners / links.</p>
                                    <p>Por favor, não dê incentivos / recompensas aos clientes para ingressar na Trinka.
                                    </p>
                                    <p>Além disso, evite licitar as marcas comerciais “Trinka” ou ““ Trinka.ai ”ou quaisquer variantes das mesmas, incluindo grafia incorreta. Além disso, evite usar esses nomes de marcas registradas em nomes de domínio ou metatags ou vincule diretamente ao nosso site a partir de anúncios pay-per-click.</p>
                                    <p style="margin: 0;">Além disso, proibimos licitar nas palavras-chave de marca e sem marca listadas abaixo:</p>
                                    <p>Trinka, Trinka AI, trinka.ai, www.trinka.ai, verificador de plágio, verificador gramatical, verificação gramatical, verificação de plágio, verificador de plágio grátis, verificador gramatical grátis, verificador gramatical online, assistente de redação, assistente de redação acadêmica, assistente de redação técnica, revisão. </p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-4">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-4"
                                        aria-expanded="false" aria-controls="collapse-4">
                                        Quais são os benefícios de se tornar um Afiliado?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-4" class="collapse" data-parent="#accordion" aria-labelledby="heading-4">
                                <div class="card-body">
                                    <p>Nossa estrutura de comissão excepcional oferece uma comissão de vendas de 25% do valor da transação por conversão. Cada link em seu site tem um código de rastreamento específico. Cada vez que um cliente clica em seu site para o site da trinka.ai e atualiza para um plano pago, documentamos essa conversão e a atribuímos à sua conta. A qualquer momento, você pode ver suas conversões e ganhos no painel de controle ou na seção Relatórios no ShareASale. Os afiliados ganham comissões quando os usuários fazem upgrade para planos premium em 90 dias após a primeira visita ao site graças à janela estendida de cookies de 90 dias.
                                    </p>
                                        <p><strong>Nota: </strong>Todos os pagamentos serão feitos apenas em dólares americanos. Certifique-se de que o seu banco aceita dólares americanos se você não estiver nos EUA.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-5">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-5"
                                        aria-expanded="false" aria-controls="collapse-5">
                                        Quais são os termos e condições do Programa de Afiliados Trinka?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-5" class="collapse" data-parent="#accordion" aria-labelledby="heading-5">
                                <div class="card-body">
                                    <p>Visite <a href="https://www.trinka.ai/termsofservices/"
                                            target="_blank">este link</a> para ler nossos termos e condições</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="bottom_shareAsale_buttons">
                        <a id="signUpAtShareASaleFooter" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            Inscreva-se no ShareASale
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>